import type {Settings} from "@pata/settings";
import {ComponentHeaderLogo} from "@/components/header-logo";
import {ComponentFooterLogo} from "@/components/footer-logo";
import {ComponentAddressInfo} from "@/components/address-info";
import {ComponentEmailLogo} from "@/components/email-logo";
import ComponentContactSectionText from "@/components/contact-section-text";

const presets: Settings["presets"] = {
    headerLogo: ComponentHeaderLogo,
    footerLogo: ComponentFooterLogo,
    emailLogo: ComponentEmailLogo,
    footerAddress: ComponentAddressInfo,
    sectionContactText: ComponentContactSectionText,
}
export default presets